import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './signup.css';
import bcrypt from 'bcryptjs';
import {useFormik } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  email: Yup.string().email('Invalid email address').required('Email is required'),
  password: Yup.string().min(6, 'Password must be at least 6 characters').required('Password is required')
});

function Signup() {
  const [submitted, setSubmitted] = useState(false);

 const FRONTEND_SALT = '$2a$10$ReactClientSideSaltKeye'; 
  
     const formik = useFormik({
      initialValues: {
       name: '',
       email: '',
       password: '',      
      },

      validationSchema: validationSchema,

     onSubmit: (values, { setSubmitting }) => {
        fetch('https://backend.zenithcbe.com/signup',
        {
         method: 'POST',
        headers: {
        'Content-Type': 'application/json',
      }, body: JSON.stringify({
        name: values.name,
        email: values.email,
        password: bcrypt.hashSync(values.password, FRONTEND_SALT),
      }),
             
      
      });
     },

   })

  return (
    <main className="page">
      <section className="hero">
        <p className="eyebrow">Create account</p>
        <h1>Sign up for a currency dashboard.</h1>
        <p>Start tracking exchange rates and managing your personal currency view.</p>

        <form className="signup-form" method="POST" onSubmit={ formik.handleSubmit }>
          <div className="signup-field">
            <label htmlFor="name">Full name</label>
            <input
              id="name"
              name="name"
              value={formik.values.name}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              placeholder="Jane Doe"
            />

               {formik.touched.name && formik.errors.name ? (
         <div className="form-error">{formik.errors.name}</div>
       ) : null}
          </div>

          <div className="signup-field">
            <label htmlFor="email">Email address</label>
            <input
              id="email"
              name="email"
              value={formik.values.email}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              placeholder="jane@example.com"
            />
             {formik.touched.email && formik.errors.email ? (
         <div className="form-error">{formik.errors.email}</div>
       ) : null}
          </div>

          <div className="signup-field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              name="password"
              value={formik.values.password}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              placeholder="Create a secure password"
            />
             {formik.touched.password && formik.errors.password ? (
         <div className="form-error">{formik.errors.password}</div>
         
       ) : null}
          </div>

          <button className="primary-btn" type="submit">
            Create account
          </button>
        </form>

        {submitted && (
          <div className="form-alert">
            Thanks, {formik.values.name || 'there'}! Your signup form was submitted.
          </div>
        )}

        <p className="form-note">
          Already have an account? <Link to="/login">Log in</Link> or return to the homepage.
        </p>
      </section>
    </main>
  );
}

export default Signup;
